module.exports = __webpack_public_path__ + "img/glogo_dark.1bb80544.svg";